<template>
  <div class="enterprise-list-page enterprise-list-page--warehouse">

    <!-- Header Alert -->
    <b-alert
      show
      variant="light"
      class="alert alert-custom alert-white alert-shadow fade show gutter-b">
      <div class="alert-icon">
        <span class="svg-icon svg-icon-lg">
          <inline-svg src="/media/svg/icons/Tools/Compass.svg" />
        </span>
      </div>
      <div class="alert-text">
        Daftar <b>Gudang</b> yang ada di {{ clinic_name }}
      </div>
      <b-button
        squared
        variant="success"
        @click="$router.push('/masters/warehouses/add')"
        v-if="btn">Tambah</b-button>
    </b-alert>

    <!-- Component List -->
    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>

            <modern-filter-bar embedded single-line :show-timeseries="false"
              :search-text.sync="filter.name" search-placeholder="Cari gudang"
              @search-keyup="filterByName" />

            <!-- Table -->
            <medhop-data-table summary-title="Daftar Gudang"
              striped
              hover
              class="mt-3"
              :items="items"
              :fields="fields"
              :style="'white-space: nowrap'"
              responsive="sm">
              <template #table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.key === 'actions' ? '15%' : '' }" />
              </template>
              <template #cell(actions)="data">
                <b-button
                  size="sm"
                  class="mr-1 btn-info"
                  v-b-tooltip.hover
                  title="Detail"
                  @click="$router.push({ path: '/masters/warehouses/detail/' + data.item.id, })"><i class="fas fa-eye px-0"></i></b-button>
                <b-button
                  size="sm"
                  class="mr-1 btn-success"
                  v-b-tooltip.hover
                  title="Edit"
                  @click="$router.push({ path: '/masters/warehouses/edit/' + data.item.id, })"
                  v-if="btn"><i class="fas fa-edit px-0"></i></b-button>
                <b-button
                  size="sm"
                  class="btn-danger"
                  v-b-tooltip.hover
                  title="Hapus"
                  @click="deleteData(data.item.id)"
                  v-if="btn"><i class="fas fa-trash px-0"></i></b-button>
              </template>
            </medhop-data-table>
            <medhop-pagination
              v-if="items.length != 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @page-click="pageOnClick"
              class="mt-4"></medhop-pagination>
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import { debouncer } from "@/core/modules/Helper.js"
import module from "@/core/modules/CrudModule.js"
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"
import "@riophae/vue-treeselect/dist/vue-treeselect.css"

export default {

  name: "List",

  components: {
    Card,
  },

  data() {
    return {
      // Filter
      filter: {
        name: '',
        building_id: ''
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
        },
        {
          key: "address",
          label: "Alamat",
          sortable: true,
        },
        {
          key: "description",
          label: "Keterangan",
          sortable: true,
        },
        // {
        //   key: "description",
        //   label: "Deskripsi",
        //   sortable: true,
        // },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      // Options
      buildings: [],
      // user access
      btn: false,
      clinic_name: window.configuration == null ? "Medhop" : window.configuration.clinic_name
    }
  },

  methods: {

    pageOnClick(page) {
      this.currentPage = page
      this.pagination()
    },

    async pagination() {
      let filterParams = `&name=${this.filter.name}`
      let response = await module.paginate('warehouses', `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      let pagination = response.meta.pagination
      this.totalRows = pagination.total

      let a, b
      b = this.perPage * (this.currentPage - 1) + 1
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a
      }

      this.items = response.data
    },

    async filterByBuilding(evt) {
      await this.filter.building_id
      this.pagination()
    },

    filterByName() {
      debouncer(() => { this.currentPage = 1; this.pagination() }, 500)
    },

    async deleteData(id) {
      // Delete Data
      let result = await module.delete("warehouses/" + id)
      // If Deleted
      if (result) {
        this.pagination()
      }
    },

    setActiveButton() {
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "1802") {
          this.btn = true
        }
      }
    },
  },

  watch: {
    // 'filter.building_id': function(newVal, oldVal) {
    //   if (typeof newVal === 'undefined') {
    //     this.filter.building_id = ''
    //     this.filterByBuilding()
    //   }
    // }
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Gudang" }])
    // Get Data    
    this.pagination()
    this.setActiveButton()
  },

}
</script>
